import {BehaviorSubject, Subject} from 'rxjs';
import {filter, switchMap} from 'rxjs/operators';
import {mc} from '@px/helper/mc';
import {imApi} from '@px/api/im';
import {readBid} from '@px/storage/bid';
import {userInfo$} from './user';

export type CsRobotType = 'PhemexBot' | 'AdaZAW';

export interface CsRobotInfo {
  name: CsRobotType;
  widget: string;
  countryCodeFieldId?: string;
}

const DefaultCsRobotType = {
  name: 'AdaZAW',
  widget: null,
};

export const loadChatReady$ = new BehaviorSubject(false);
export const loadRobotInfo$ = new Subject<void>();
export const csRobotInfo$ = new BehaviorSubject<CsRobotInfo>(null);

loadRobotInfo$.pipe(switchMap(loadCsRobotInfo), filter(Boolean)).subscribe();

export async function getCsRobotInfo(): Promise<CsRobotInfo> {
  const csRobotInfo = csRobotInfo$.getValue();
  if (csRobotInfo) {
    return csRobotInfo;
  }
  const type = await loadCsRobotInfo();

  return type;
}

async function loadCsRobotInfo(): Promise<CsRobotInfo> {
  const userInfo = userInfo$.getValue();
  const {data, error} = await imApi.getCsRobotInfo({bid: readBid(), user: userInfo.userId});
  if (error) {
    mc.send('toast', 'error', error);
  }
  if (data) {
    csRobotInfo$.next(data);
  }
  return data || DefaultCsRobotType;
}
